import React from 'react';
import Types from '../../constants/Types';
import ObjectOverride from '../ObjectOverride';
import ModuleCard from './ModuleCard';

class UpgradesList extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	render() {
		const { object, rootState, history, handleAfterSave } = this.props;
		const { locationSelected, locationSelectedBinaryId, locations, account } = rootState;
		const { upgrades, selectedActualLocation, location, location_binary_id } = object;
		const firstActiveLocation = locations.find(loc => !loc.archived);

		return (
			<>
				<hr></hr>
				<h4 style={{fontWeight: "bold"}}>Upgrades</h4>
				<div className={"row"} id={"moduleCardsContainer"}>
					{upgrades && upgrades.map((data) => {
						let found = false;
						let module = data.pkey;
						let amountSubscribed = 0;

						if(data.additional !== "" || data.additional !== null) {
							let additional = data.additional;
							if (selectedActualLocation[0][additional]) {
								amountSubscribed = selectedActualLocation[0][additional];
							}
						}

						if (amountSubscribed > 0) {
							found = true;
						}

						return (
							<ModuleCard
								parent={
									locationSelected
										? locationSelectedBinaryId
										: (
											location
												? location_binary_id
												: firstActiveLocation.binary_id
										) +
										"-" +
										(
											locationSelected
												? locationSelected
												: (location ? location : firstActiveLocation.pkey)
										)
								}
								modulePkey={module}
								moduleBinaryId={"0001"}
								binaryId={"0001"}
								account={account}
								module={module}
								moduleClass={"Location Cloud Module"}
								price={data.price}
								name={data.name ?? null}
								showName={true}
								type={data.description}
								borderStyle={found ? "#1bbc9b" : "#DBDBDB"}
								isSubscribed={found}
								amountSubscribed={amountSubscribed}
								moduleType={data.additional || ""}
								location={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								locationBinaryId={locationSelected ? locationSelectedBinaryId : (location ? location_binary_id : firstActiveLocation.binary_id)}
								locationSelected={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								history={history}
								handleAfterSave={handleAfterSave}
								key={data.id + Math.random()}
							/>
						);
					})}
				</div>
			</>
		);
	}
}

export default UpgradesList;
